import { Component, HostListener, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { MegaMenuItem, MenuItem, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as feather from 'feather-icons';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';
import { roleService } from '../../services/rolebase-services';
import { TabService } from '../../tab.service';
import { ChangeColorModalComponent } from '../change-color-modal/change-color-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { svgs } from 'src/app/icons';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-top-sidebar',
  templateUrl: './top-sidebar.component.html',
  styleUrls: ['./top-sidebar.component.css'],
  providers: [MessageService,DialogService]
})
export class TopSidebarComponent {
  
  ref: DynamicDialogRef | undefined;
  isMobile: boolean = false;
  isModuleActive:boolean=false;
  isSubModuleActive:boolean= false;
  items: MenuItem[] = [];
  themeValue = false;
  theme = 'dark'
  svgIcons = svgs
  menu : any;
  roleIds:any;
  menuNew = [
    {
      "id": 1,
      "moduleName": "Summary",
      "moduleIcon": "Calendar",
      "moduleEndpoint": "/calendar",
      "status": 1,
      "subModules": [],
      "active": false,
    },
    {
      "id": 1,
      "moduleName": "Work log",
      "moduleIcon": "WorkLog",
      "moduleEndpoint": "/worklog",
      "status": 1,
      "subModules": [],
      "active": false,
    },
    // {
    //   "id": 1,
    //   "moduleName": "Revenue Reports",
    //   "moduleIcon": "Revenue_reports",
    //   "moduleEndpoint": "/revenue-reports",
    //   "status": 1,
    //   "subModules": [],
    //   "active": false,
    // },
    // {
    //   "id": 1,
    //   "moduleName": "On Roll Salary",
    //   "moduleIcon": "On_roll_salary",
    //   "moduleEndpoint": "/on-roll-salary",
    //   "status": 1,
    //   "subModules": [],
    //   "active": false,
    // },
    {
      "id": 1,
      "moduleName": "Master",
      "moduleIcon": "User_Management",
      "status": 1,
      "active": false,
      "subModules": [
          // {
          //     "id": 1,
          //     "subModuleName": "Vendor",
          //     "subModuleDescription": "This Module for Product",
          //     "subModuleEndpoint": "/pms-master/vendors",
          //     "subModuleIcon": "Manage_Products",
          //     "readAccess": 1,
          //     "writeAccess": 1,
          //     "updateAccess": 1,
          //     "status": 1,
          //     "isDefault": 0,
          //     "active": false,
          // },
          {
            "id": 1,
            "subModuleName": "Location",
            "subModuleDescription": "This Module for Product",
            "subModuleEndpoint": "/pms-master/all-location",
            "subModuleIcon": "Location",
            "readAccess": 1,
            "writeAccess": 1,
            "updateAccess": 1,
            "status": 1,
            "isDefault": 0,
            "active": false,

        },
        {
          "id": 1,
          "subModuleName": "Employees",
          "subModuleDescription": "This Module for Employee",
          "subModuleEndpoint": "/pms-master/employees",
          "subModuleIcon": "User_Management",
          "readAccess": 1,
          "writeAccess": 1,
          "updateAccess": 1,
          "status": 1,
          "isDefault": 0,
          "active": false,

      },
      //   {
      //     "id": 1,
      //     "subModuleName": "Employees",
      //     "subModuleDescription": "This Module for Product",
      //     "subModuleEndpoint": "/pms-master/employees",
      //     "subModuleIcon": "User_Management",
      //     "readAccess": 1,
      //     "writeAccess": 1,
      //     "updateAccess": 1,
      //     "status": 1,
      //     "isDefault": 0,
      //     "active": false,

      // },
    //   {
    //     "id": 1,
    //     "subModuleName": "Department",
    //     "subModuleDescription": "This Module for Product",
    //     "subModuleEndpoint": "/pms-master/department",
    //     "subModuleIcon": "Department",
    //     "readAccess": 1,
    //     "writeAccess": 1,
    //     "updateAccess": 1,
    //     "status": 1,
    //     "isDefault": 0,
    //     "active": false,

    // },
    // {
    //   "id": 1,
    //   "subModuleName": "Designation",
    //   "subModuleDescription": "",
    //   "subModuleEndpoint": "/pms-master/designation",
    //   "subModuleIcon": "Designation",
    //   "readAccess": 1,
    //   "writeAccess": 1,
    //   "updateAccess": 1,
    //   "status": 1,
    //   "isDefault": 0,
    //   "active": false,

    // },
    //   {
    //     "id": 1,
    //     "subModuleName": "Expenses",
    //     "subModuleDescription": "This Module for Product",
    //     "subModuleEndpoint": "/pms-master/expenses",
    //     "subModuleIcon": "Expenses",
    //     "readAccess": 1,
    //     "writeAccess": 1,
    //     "updateAccess": 1,
    //     "status": 1,
    //     "isDefault": 0,
    //     "active": false,

    // },
    {
      "id": 1,
      "subModuleName": "Project",
      "subModuleDescription": "This Module for Product",
      "subModuleEndpoint": "/pms-master/projects",
      "subModuleIcon": "Project",
      "readAccess": 1,
      "writeAccess": 1,
      "updateAccess": 1,
      "status": 1,
      "isDefault": 0,
      "active": false,

  },
  {
    "id": 1,
    "subModuleName": "Quick Code",
    "subModuleDescription": "This Module for Product",
    "subModuleEndpoint": "/pms-master/quick-code",
    "subModuleIcon": "QuickCode",
    "readAccess": 1,
    "writeAccess": 1,
    "updateAccess": 1,
    "status": 1,
    "isDefault": 0,
    "active": false,

  },
  // {
  // "id": 1,
  // "subModuleName": "Revenue Attribute",
  // "subModuleDescription": "This Module for Product",
  // "subModuleEndpoint": "/pms-master/revenue-attribute",
  // "subModuleIcon": "Revenue_attribute",
  // "readAccess": 1,
  // "writeAccess": 1,
  // "updateAccess": 1,
  // "status": 1,
  // "isDefault": 0,
  // "active": false,
  // },
  // {
  // "id": 1,
  // "subModuleName": "Expenses Attribute",
  // "subModuleDescription": "This Module for Product",
  // "subModuleEndpoint": "/pms-master/expenses-attribute",
  // "subModuleIcon": "Vendor_payment_status",
  // "readAccess": 1,
  // "writeAccess": 1,
  // "updateAccess": 1,
  // "status": 1,
  // "isDefault": 0,
  // "active": false,

  // },
    ]
    },
    {
      "id": 1,
      "moduleName": "Mappings",
      "moduleIcon": "Mapping",
      "status": 1,
      "active": false,
      "subModules": [
        {
          "id": 1,
          "subModuleName": "Department HOD",
          "subModuleDescription": "Department HOD",
          "subModuleEndpoint": "/mapping/departmentHod",
          "subModuleIcon": "Department",
          "readAccess": 1,
          "writeAccess": 1,
          "updateAccess": 1,
          "status": 1,
          "isDefault": 0,
          "active": false,
        },
        {
          "id": 1,
          "subModuleName": "Employee Designation",
          "subModuleDescription": "Employee Designation",
          "subModuleEndpoint": "/mapping/employeeDesignation",
          "subModuleIcon": "Designation",
          "readAccess": 1,
          "writeAccess": 1,
          "updateAccess": 1,
          "status": 1,
          "isDefault": 0,
          "active": false,
        },
        {
          "id": 1,
          "subModuleName": "Employee Department",
          "subModuleDescription": "Employee Department",
          "subModuleEndpoint": "/mapping/employeeDepartment",
          "subModuleIcon": "Department",
          "readAccess": 1,
          "writeAccess": 1,
          "updateAccess": 1,
          "status": 1,
          "isDefault": 0,
          "active": false,
        },{
          "id": 1,
          "subModuleName": "Employee Project",
          "subModuleDescription": "Employee Project",
          "subModuleEndpoint": "/mapping/employeeProject",
          "subModuleIcon": "Project",
          "readAccess": 1,
          "writeAccess": 1,
          "updateAccess": 1,
          "status": 1,
          "isDefault": 0,
          "active": false,
        },{
          "id": 1,
          "subModuleName": "Employee Manager",
          "subModuleDescription": "Employee Manager",
          "subModuleEndpoint": "/mapping/employeeManager",
          "subModuleIcon": "Manager",
          "readAccess": 1,
          "writeAccess": 1,
          "updateAccess": 1,
          "status": 1,
          "isDefault": 0,
          "active": false,
        },
      ]
    },
    // {
    //   "id": 1,
    //   "moduleName": "Invoice",
    //   "moduleIcon": "All_invoice",
    //   // "moduleEndpoint": "/invoice",
    //   "status": 1,
    //   "active": false,
    //   "subModules": [
    //     {
    //       "id": 1,
    //       "subModuleName": "All Invoices",
    //       "subModuleDescription": "Invoice",
    //       "subModuleEndpoint": "/invoices/all-invoice",
    //       "subModuleIcon": "All_invoice",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "All Invoices (User)",
    //       "subModuleDescription": "All Invoice (User)",
    //       "subModuleEndpoint": "/invoices/all-invoice-user",
    //       "subModuleIcon": "All_invoice_user",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "Import Expenses",
    //       "subModuleDescription": "Import Expenses",
    //       "subModuleEndpoint": "/invoices/import-expenses",
    //       "subModuleIcon": "Import_expense",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "My Invoices",
    //       "subModuleDescription": "My Invoices",
    //       "subModuleEndpoint": "/invoices/my-invoices",
    //       "subModuleIcon": "My_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "My Invoice List",
    //       "subModuleDescription": "My Invoice List",
    //       "subModuleEndpoint": "/invoices/my-invoice-list",
    //       "subModuleIcon": "My_Invoice_list",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "Open Invoices",
    //       "subModuleDescription": "Open Invoices",
    //       "subModuleEndpoint": "/invoices/open-invoices",
    //       "subModuleIcon": "Open_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "Pending Invoices",
    //       "subModuleDescription": "Pending Invoices",
    //       "subModuleEndpoint": "/invoices/pending-invoices",
    //       "subModuleIcon": "Pending_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "Commented Invoices",
    //       "subModuleDescription": "Commented Invoices",
    //       "subModuleEndpoint": "/invoices/commented-invoices",
    //       "subModuleIcon": "Commented_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "Approved Invoices",
    //       "subModuleDescription": "Approved Invoices",
    //       "subModuleEndpoint": "/invoices/approved-invoices",
    //       "subModuleIcon": "Approved_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "Rejected Invoices",
    //       "subModuleDescription": "Rejected Invoices",
    //       "subModuleEndpoint": "/invoices/rejected-invoices",
    //       "subModuleIcon": "Rejected_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "All Approved Invoices",
    //       "subModuleDescription": "All Approved Invoices",
    //       "subModuleEndpoint": "/invoices/all-approved-invoices",
    //       "subModuleIcon": "All_approved_invoices",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //     {
    //       "id": 1,
    //       "subModuleName": "All Invoice Status Dumps",
    //       "subModuleDescription": "All Invoice Status Dumps",
    //       "subModuleEndpoint": "/invoices/all-invoice-status-dumps",
    //       "subModuleIcon": "All_invoice_status_dump",
    //       "readAccess": 1,
    //       "writeAccess": 1,
    //       "updateAccess": 1,
    //       "status": 1,
    //       "isDefault": 0,
    //       "active": false,
    //     },
    //   ]
    // },
    {
      "id": 1,
      "moduleName": "Approvals",
      "moduleIcon": "Approvals",
      "status": 1,
      "active": false,
      "subModules": [
          {
              "id": 1,
              "subModuleName": "Worklog",
              "subModuleDescription": "",
              "subModuleEndpoint": "/approvals/worklog",
              "subModuleIcon": "WorkLog",
              "readAccess": 1,
              "writeAccess": 1,
              "updateAccess": 1,
              "status": 1,
              "isDefault": 0,
              "active": false,
          },
          {
            "id": 1,
            "subModuleName": "Cost",
            "subModuleDescription": "",
            "subModuleEndpoint": "/approvals/cost",
            "subModuleIcon": "Cost",
            "readAccess": 1,
            "writeAccess": 1,
            "updateAccess": 1,
            "status": 1,
            "isDefault": 0,
            "active": false,
          },
        ]
      },
    {
      "id": 1,
      "moduleName": "Reports/Dashboard",
      "moduleIcon": "ReportDashboard",
      "status": 1,
      "active": false,
      "subModules": [
          {
              "id": 1,
              "subModuleName": "Project Summary",
              "subModuleDescription": "This Module for Product",
              "subModuleEndpoint": "/reports/consolidated-manpower-report",
              "subModuleIcon": "ProjectSummary",
              "readAccess": 1,
              "writeAccess": 1,
              "updateAccess": 1,
              "status": 1,
              "isDefault": 0,
              "active": false,
          },
          {
            "id": 1,
            "subModuleName": "Most Active Project",
            "subModuleDescription": "This Module for Product",
            "subModuleEndpoint": "/reports/consolidated-expense-report",
            "subModuleIcon": "ActiveProject",
            "readAccess": 1,
            "writeAccess": 1,
            "updateAccess": 1,
            "status": 1,
            "isDefault": 0,
            "active": false,
          },
          {
            "id": 1,
            "subModuleName": "Project Timelines",
            "subModuleDescription": "This Module for Product",
            "subModuleEndpoint": "/reports/consolidated-expense-report",
            "subModuleIcon": "ProjectTimeline",
            "readAccess": 1,
            "writeAccess": 1,
            "updateAccess": 1,
            "status": 1,
            "isDefault": 0,
            "active": false,
          },
        ]
      },
      {
        "id": 1,
        "moduleName": "Access Management",
        "moduleIcon": "Reports",
        "status": 1,
        "active": false,
        "subModules": [
            {
                "id": 1,
                "subModuleName": "User Management",
                "subModuleDescription": "",
                "subModuleEndpoint": "/access-management-services/user-management",
                "subModuleIcon": "Cons_manpower_report",
                "readAccess": 1,
                "writeAccess": 1,
                "updateAccess": 1,
                "status": 1,
                "isDefault": 0,
                "active": false,
            },
            {
              "id": 1,
              "subModuleName": "Role Management",
              "subModuleDescription": "",
              "subModuleEndpoint": "/access-management-services/role-management",
              "subModuleIcon": "Cons_expense_report",
              "readAccess": 1,
              "writeAccess": 1,
              "updateAccess": 1,
              "status": 1,
              "isDefault": 0,
              "active": false,
            },
          ]
        },
      // {
      //   "id": 1,
      //   "moduleName": "Common Upload",
      //   "moduleIcon": "Common_Upload",
      //   "moduleEndpoint": "/utility/upload",
      //   "status": 1,
      //   "subModules": [],
      //   "active": false,
      // }, 
        
  ];
  showLoader = true
  showLogoutPopup = false
  menuItems: any;
  constructor(private auth: AuthService, public roleService: roleService,public themeService: ThemeService,public router: Router,private sanitizer: DomSanitizer,private sharedService: SharedService,
    private renderer: Renderer2,public dialogService: DialogService,private tabService: TabService) {
    document.body.classList.add('top-sidebar')
    this.checkIfMobile();
  }
  
  ngAfterViewInit() {
    feather.replace();
  }

  ngOnInit() {
    const theme = localStorage.getItem('darkTheme')
    this.themeValue = theme === 'true' ? true : false
    // this.roleService.fetchRoleList();
    const userData = JSON.parse(localStorage.getItem('user_details') || '{}');
    if (userData.userRole && Array.isArray(userData.userRole)) {
      this.roleIds = userData.userRole.map((role: any) => role.id);
    } else {
      console.log('No userRole data found');
    }
    this.sharedService.updateLoader(true);
    if(this.roleIds){
      this.getModuleSubmodule(this.roleIds)
    }
    const bgType = localStorage.getItem('bgType');
    const primaryColor = localStorage.getItem('backgroundPrimaryColor')
    document.documentElement.style.setProperty('--background-primary-color', primaryColor);
    document.documentElement.style.setProperty('--background-primary-hover-color', (primaryColor + '14'));
    const mainBgColor = localStorage.getItem('backgroundMainColor')
    if(bgType === 'gradiant'){
      document.body.style.backgroundColor = ''
      document.body.style.setProperty('--main-background-color', mainBgColor);
    }
    else{
      document.body.style.setProperty('--main-background-color', mainBgColor);
      document.body.style.backgroundColor = mainBgColor!
    }
    const sidebarBgColor = localStorage.getItem('backgroundSidebarColor')
    document.documentElement.style.setProperty('--sidebar-background-color', sidebarBgColor);
    const mainTextColor = localStorage.getItem('mainTextColor')
    document.documentElement.style.setProperty('--main-text-color', mainTextColor);
    this.items = [
      {
        label: 'Manage Product',
        icon: 'pi pi-fw pi-user',
        routerLink:"/product-services/product-list"
      },
      {
        label: 'Manage Product Attributes',
        icon: 'pi pi-fw pi-user',
        routerLink:"/product-services/product-attribute"
      },
      {
        label: 'Upload Products',
        icon: 'pi pi-fw pi-user',
        routerLink:"/product-services/upload-product"
      },
    ];
    // // this.getWarehouseList()
    // this.menuItems = this.menuNew.map((el: any) => {
    //   el.subModules.forEach((ele: any) => {
    //     console.log(">>>>>>>>>>...", ele);
    //     const submoduleIcon = ele.subModuleIcon;
    //     console.log(submoduleIcon);
    //     if (svgs[submoduleIcon]) {
    //       ele.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[submoduleIcon]);
    //     }
    //   });
    //   return el; // Make sure to return the modified element to create the new array
    // });
    // console.log(this.menuItems)

    // this.menuItems = this.menuNew.forEach((el:any)=>{
    //   const moduleIcon = el.moduleIcon; 
    //       if (svgs[moduleIcon]) {
    //         el.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[moduleIcon]);
    //       }
    //   el.subModules.forEach((ele:any)=>{
    //     const subModuleIcon = ele.subModuleIcon; 
    //     if (svgs[subModuleIcon]) {
    //       ele.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[subModuleIcon]);
    //     }
    //   })
    // })
    this.menuItems = this.menuNew.map((el: any) => {
      const moduleIcon = el.moduleIcon; 
          if (svgs[moduleIcon]) {
            el.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[moduleIcon]);
          }
      el.submodulePermissions.forEach((ele: any) => {
        // console.log(">>>>>>>>>>...", ele);
        const submoduleIcon = ele.subModuleIcon;
        // console.log(submoduleIcon);
        if (svgs[submoduleIcon]) {
          ele.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[submoduleIcon]);
        }
      });
      return el; // Make sure to return the modified element to create the new array
    });
    // console.log(this.menuItems)
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile(); // Check whenever the window is resized
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth < 769; 
  }

  toggleNavMobile() {
    if (this.isMobile) {
      const toggleBtn: any = document.getElementById('mobile_btn');

      const body = document.body;
      // const wrapper = document.querySelector(".main-wrapper");

      if (document.querySelector(".slide-nav")) {
        document.querySelector(".main-wrapper")?.classList.remove("slide-nav");

        body.classList.remove('menu-opened');
        // toggleBtn.classList.add('active');
        // localStorage.setItem(screenModeNightTokenState, 'night');
        setTimeout(() => {
          body.classList.remove('mini-sidebar');
          document.querySelector(".header-left")?.classList.add("active");
        }, 100);
      } else {
        document.querySelector(".main-wrapper")?.classList.add("slide-nav");

        body.classList.add('menu-opened');
        toggleBtn.classList.remove('active');
        // localStorage.removeItem(screenModeNightTokenState);
        setTimeout(() => {
          body.classList.add('mini-sidebar');
          document.querySelector(".header-left")?.classList.remove("active");
        }, 100);
      }
    }
  }
  logOut() {
    this.auth.logOut()
  }
  toggleTheme() {
    this.themeService.toggleTheme();
  }

  // getWarehouseList() {
  //   // const userDetails = this.getUserDetails
  //   // this.getUserDetails = JSON.parse(userDetails)
  //   const id = 0
  //   // const extractedIds = this.getUserDetails?.userWarehouseMapping.map((item: any) => item.warehouseId);
  //   this.auth.getWarehouseId(id).subscribe((res: any) => {
  //     const wareHouseList = res?.responseObject
  //     localStorage.setItem('wareHouseList', JSON.stringify(wareHouseList))
  //   })
  // }

  changeTheme(){
    this.ref = this.dialogService.open(ChangeColorModalComponent, {
      // header: 'Select a Product',
      width: '35vw',
      data: {
        type: 'user'
      },
      contentStyle: { overflow: 'auto' },
      draggable: true
      // breakpoints: {
      //   '960px': '75vw',
      //   '640px': '90vw',
      // },
      // templates: {
      //   footer: Footer,
      // },
    });
  
    this.ref.onClose.subscribe((data: any) => {
      let summary_and_detail;
      if (data) {
        setTimeout(() => {
          this.showLogoutPopup = true
        }, 100);
      } else {
        
      }
      // this.messageService.add({
      //   severity: 'info',
      //   ...summary_and_detail,
      //   life: 3000,
      // });
    });
  }
  addNewTab(item:any) {
    this.tabService.addTab({
      label: item.subModuleName, path: item.subModuleEndpoint,
      fullPath: '',
      filterData: []
    });
  }
  addNewTabmaster(item:any) {
    this.tabService.addTab({
      label: item.moduleName, path: item.moduleEndpoint,
      fullPath: '',
      filterData: []
    });
  }
  getModuleSubmodule(ids:any){
    this.auth.getModuleSubmodule(ids).subscribe((res:any)=>{
      this.menu = res.responseObject
      this.menu.forEach((el:any)=>{
        const moduleIcon = el.moduleIcon; 
            if (svgs[moduleIcon]) {
              el.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[moduleIcon]);
            }
        el.submodulePermissions.forEach((ele:any)=>{
          const subModuleIcon = ele.subModuleIcon; 
          if (svgs[subModuleIcon]) {
            ele.icon = this.sanitizer.bypassSecurityTrustHtml(svgs[subModuleIcon]);
          }
        })
      })
      this.showLoader = false
      this.sharedService.updateLoader(false);
    },(error:any)=>{
      this.sharedService.updateLoader(false);
      this.showLoader = false
    })
  }
}
